import type React from 'react'
import { forwardRef } from 'react'

interface ClickableProps extends Omit<React.HTMLAttributes<HTMLDivElement>, 'onClick'> {
  onClick: () => void
  children: React.ReactNode
}

/**
 * The most simple clickable element
 */
const Clickable = forwardRef<HTMLDivElement, ClickableProps>(({ onClick, children, ...props }, ref) => (
  <div
    ref={ref}
    onClick={onClick}
    role="button"
    onKeyDown={e => {
      if (e.key === 'Enter' || e.key === ' ') {
        onClick()
      }
    }}
    tabIndex={0}
    {...props}
  >
    {children}
  </div>
))

export default Clickable
